import { Link } from "react-router-dom";
import { CalendarCheck, FileText } from "lucide-react";
import { Reveal } from "./Reveal";

export const CTABand = () => (
  <section data-testid="cta-band" className="py-20 lg:py-24 bg-brand-mist/60">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <Reveal>
        <div className="rounded-[2rem] bg-brand-navy px-8 py-14 md:p-16 flex flex-col lg:flex-row lg:items-center justify-between gap-10 shadow-[0_24px_60px_rgb(11,27,61,0.18)]">
          <div>
            <h2 className="font-display text-3xl md:text-4xl text-white tracking-tight">Not sure where to begin?</h2>
            <p className="mt-4 max-w-xl text-lg leading-relaxed text-slate-300">
              Book a free, no-obligation care consultation. We will listen to your needs, answer your questions, and help you find the right support for yourself or your loved one.
            </p>
          </div>
          <div className="flex flex-wrap gap-4 shrink-0">
            <Link
              to="/contact"
              data-testid="cta-band-consultation"
              className="inline-flex items-center gap-2.5 whitespace-nowrap rounded-full bg-brand-teal px-7 py-4 text-base md:text-lg font-bold text-white hover:bg-brand-cyan hover:text-brand-navy transition-colors duration-300 active:scale-95"
            >
              <CalendarCheck className="h-5 w-5" strokeWidth={1.8} />
              Book a Free Care Consultation
            </Link>
            <Link
              to="/referral"
              data-testid="cta-band-referral"
              className="inline-flex items-center gap-2.5 whitespace-nowrap rounded-full border border-white/40 px-7 py-4 text-base md:text-lg font-bold text-white hover:bg-white hover:text-brand-navy transition-colors duration-300 active:scale-95"
            >
              <FileText className="h-5 w-5" strokeWidth={1.8} />
              Refer a Patient
            </Link>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
